import usePdvAccess from './usePdvAccess.hook';

const useIsTotemHook = () => {
  const { isTotem } = usePdvAccess();

  return isTotem;
};

export default useIsTotemHook;
